"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function _export(target, all) {
  for (var name in all) Object.defineProperty(target, name, {
    enumerable: true,
    get: all[name]
  });
}
_export(exports, {
  dim: () => dim,
  default: () => _default
});
const _picocolors = /*#__PURE__*/_interopRequireDefault(require("picocolors"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
let alreadyShown = new Set();
function log(type, messages, key) {
  if (typeof process !== "undefined" && process.env.JEST_WORKER_ID) return;
  if (key && alreadyShown.has(key)) return;
  if (key) alreadyShown.add(key);
  console.warn("");
  messages.forEach(message => console.warn(type, "-", message));
}
function dim(input) {
  return _picocolors.default.dim(input);
}
const _default = {
  info(key, messages) {
    log(_picocolors.default.bold(_picocolors.default.cyan("info")), ...(Array.isArray(key) ? [key] : [messages, key]));
  },
  warn(key, messages) {
    log(_picocolors.default.bold(_picocolors.default.yellow("warn")), ...(Array.isArray(key) ? [key] : [messages, key]));
  },
  risk(key, messages) {
    log(_picocolors.default.bold(_picocolors.default.magenta("risk")), ...(Array.isArray(key) ? [key] : [messages, key]));
  }
};